import PropTypes from 'prop-types'
import { useState } from 'react'
import { NotPermissionAccess } from '../common/notPermissionAccess/NotPermissionAccess'
import { TrialListPopup } from '../dashboard/components/currentPlan/components/TrialListPopup'
import { PopupUpgrade } from '../userManagement/subscriptionPayment/common/popupUpgrade'
import { ErrorCommon } from './ErrorCommon'
import './lang/i18n'

export const errorTypes = {
  INTERNAL_SERVER: {
    key: 'INTERNAL_SERVER',
    statusCode: 500,
    title: 'error.SERVER_ERROR',
  },
  FORBIDDEN: {
    key: 'FORBIDDEN',
    statusCode: 403,
    title: 'error.FORBIDDEN',
    renderAppendContent: (setIsShowViewPlan, setShowTrial) => (
      <div className="mt3">
        <NotPermissionAccess
          setIsShowViewPlan={setIsShowViewPlan}
          setShowTrial={setShowTrial}
        />
      </div>
    ),
  },
  NOT_FOUND: {
    key: 'NOT_FOUND',
    statusCode: 404,
    title: 'error.NOT_FOUND',
  },
  NOT_FOUND_ORGANIZATION_ID: {
    key: 'NOT_FOUND_ORGANIZATION_ID',
    statusCode: 404,
    title: 'error.NOT_FOUND',
  },
  ERROR_454: {
    key: 'ERROR_454',
    statusCode: 454,
    title: 'error.ERROR_454',
    isLogout: true,
  },
}

const ErrorCustom = ({ errorType }) => {
  const { statusCode, title, renderAppendContent, isLogout } =
    errorTypes[errorType.key]

  const [isShowViewPlan, setIsShowViewPlan] = useState(false)
  const [isShowTrial, setShowTrial] = useState(false)

  const handleCloseTrial = () => {
    setShowTrial(false)
  }

  return (
    <>
      <ErrorCommon
        statusCode={statusCode}
        title={title}
        renderAppendContent={renderAppendContent}
        setIsShowViewPlan={setIsShowViewPlan}
        setShowTrial={setShowTrial}
        isLogout={isLogout}
      />
      <PopupUpgrade isShow={isShowViewPlan} setIsShow={setIsShowViewPlan} />
      {isShowTrial && (
        <TrialListPopup isShow={isShowTrial} handleClose={handleCloseTrial} />
      )}
    </>
  )
}

ErrorCustom.propTypes = {
  errorType: PropTypes.shape({
    key: PropTypes.string.isRequired,
    statusCode: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    renderAppendContent: PropTypes.func,
  }).isRequired,
}

export default ErrorCustom
